/**
 * Certifications -- Badges des certifications obtenues.
 *
 * Role : afficher les certifs professionnelles (nom, emetteur, date, lien
 * de verification). Aide a valider objectivement les competences declarees
 * dans Skills.
 *
 * Structure : grille de cards. Chaque cert a une image de badge, cliquable
 * vers l'URL de credential (verifiable publiquement).
 *
 * Donnees : hardcodees ici, dans le tableau `certifications`. Migrera vers
 * l'API en Sprint 004 (endpoint `GET /api/v1/certifications`), avec le
 * BackOffice permettant l'ajout facile de nouvelles certifs.
 *
 * Images des badges : stockees dans `frontend/public/` (ex: `g-cyber.png`,
 * `ibm_devops.png`). Ces fichiers sont servis directement par Nginx en prod.
 */

import React from 'react';

const Certifications: React.FC = () => {
  const certifications = [
    {
      title: "UCI Project Management Certificat",
      organization: "University of California, Irvine",
      date: "2024",
      image: "/uci-pm.png"
    },
    {
      title: "Comptia Security +",
      organization: "ComptTia",
      date: "2025",
      image: "/g-cyber.png"
    },
    {
      title: "Google Project Management Certificat",
      organization: "Google ",
      date: "2025",
      image: "/g-pm.png"
    },
    {
      title: "Google Cloud Achitect",
      organization: "Google ",
      date: "2025",
      image: "/gc-achi.png"
    },
    {
      title: "IBM DEVOPS Professional Certificate",
      organization: "IBM",
      date: "2025",
      image: "/ibm_devops.png"
    },
    {
      title: "Google Cybersecurity Professional (GCP)",
      organization: "Google",
      date: "2025",
      image: "/g-cyber.png"
    }
  ];

  return (
    <section id="certifications" className="py-16 bg-base-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-extrabold text-center mb-12">
          Certifications & Formations
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {certifications.map((cert, index) => (
            <div key={index} className="card bg-base-100 shadow-xl hover:shadow-2xl transition-all duration-300">
              <figure className="px-10 pt-10">
                <img
                  src={cert.image}
                  alt={cert.title}
                  className="rounded-xl h-32 object-contain"
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.src = 'https://placehold.co/200x100?text=Certificate';
                  }}
                />
              </figure>
              <div className="card-body items-center text-center">
                <h3 className="card-title text-lg font-bold">{cert.title}</h3>
                <p className="text-primary">{cert.organization}</p>
                <p className="text-sm opacity-70">{cert.date}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Certifications;
